<template>
	<div class="ordermanager">
		<el-card>
			<el-tabs v-model="activeName" @tab-click="GetTabData">
				<el-tab-pane :label="tab.name" :name="tab.name" v-for="tab in tabs" :key="tab.l_id">
					<span slot="label">{{ tab.name }} ({{ tab.count }})</span>
					<el-row>
						<el-col :span="17">
							<handlerbutton :handlerlist="tab.buttons" @buttonhandle="buttonhandle"></handlerbutton>
							<span style="color:transparent" v-if="tab.buttons.length < 1">占位</span>
						</el-col>
						<el-col :span="1" class="rightcol"><el-button icon="el-icon-refresh-right" circle size="mini" @click.native="ResetFilterInfo()"></el-button></el-col>
						<el-col :span="4"><el-input placeholder="搜索" v-model="searchbox" size="small" @keyup.enter.native="refreshgrid(true)"></el-input></el-col>
						<el-col :span="2" class="rightcol">
							<el-popover placement="bottom-end" :width="filterlist.length > 0 ? 500 : 300" trigger="click">
								<table class="htmltable">
									<tr>
										<td><label>订单号</label></td>
										<td><el-input type="textarea" rows="3" v-model="searchlist.p_pkval" size="mini"></el-input></td>
										<td rowspan="5" valign="top" class="filter" v-if="filterlist.length > 0">
											<div>常用筛选</div>
											<ul>
												<li v-for="(item, index) in filterlist">
													<el-radio v-model="searchlist.fixfilter" :label="item.fname" @change="Setfilterchecked">{{ item.fname }}</el-radio>
												</li>
											</ul>
										</td>
									</tr>
									<tr>
										<td><label>快递单号</label></td>
										<td><el-input type="textarea" rows="3" v-model="searchlist.expressid" size="mini"></el-input></td>
									</tr>
									<tr>
										<td><label>批次号</label></td>
										<td><el-input v-model="searchlist.p_batch" size="mini"></el-input></td>
									</tr>
									<tr>
										<td><label>商品名称</label></td>
										<td><el-input v-model="searchlist.cname" size="mini"></el-input></td>
									</tr>
									<tr>
										<td><label>下单时间</label></td>
										<td style="text-align:left;">
											<el-date-picker
												v-model="searchlist.starttime"
												type="date"
												placeholder="选择开始日期"
												size="mini"
												value-format="yyyy-MM-dd"
											></el-date-picker>
										</td>
									</tr>
									<tr>
										<td><label>至</label></td>
										<td>
											<el-date-picker
												v-model="searchlist.endtime"
												type="date"
												placeholder="选择结束日期"
												size="mini"
												value-format="yyyy-MM-dd"
											></el-date-picker>
										</td>
									</tr>
									<tr>
										<td colspan="4" class="bottombtn">
											<el-button @click="GetTabData()" type="warning" size="mini">查询</el-button>
											<el-button @click="ClearSearch(0)" size="mini">清空</el-button>
										</td>
									</tr>
								</table>

								<el-link slot="reference" type="primary">更多筛选</el-link>
							</el-popover>
						</el-col>
					</el-row>
					<el-row style="height:10px;"></el-row>
					<el-row>
						<el-col :span="24">
							<tableui
								style="width:100%;"
								v-loading="loading"
								ref="orderlisttable"
								editcell="0"
								:tableData="packagelist"
								:columns="tab.columns"
								@gridhandle="gridhandle"
								:gridheight="gridheight"
								@gridsort="gridsort"
								@checkboxchange="checkboxchange"
							></tableui>
						</el-col>
					</el-row>
				</el-tab-pane>
			</el-tabs>
		</el-card>
		<el-dialog :visible.sync="showprintwin" title="选择模板" width="600px" :close-on-click-modal="false" lock-scroll :modal-append-to-body="false" :show-close="false">
			<el-select v-model="selectedprintmodeindex" filterable placeholder="请选择" @change="changeprintmode">
				<el-option v-for="item in printmode" :key="item.e_code" :label="item.e_modename + '-' + item.e_modename" :value="item.e_code"></el-option>
			</el-select>
			<span slot="footer" class="dialog-footer">
				<footerhandler permissionid="" :footerbtn="footerbtn_print" winname="selectprintmode" @footerhandle="footerhandle" @closedialog="closedialog"></footerhandler>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import handlerbutton from '@/components/handlerbutton/handler.vue';
import tableui from '@/components/table/tablegrid.vue';
import Utils from '../../lib/util.js';
import footerhandler from '@/components/handlerbutton/footerhandler.vue';
export default {
	components: {
		tableui,
		handlerbutton,
		footerhandler
	},
	data() {
		return {
			searchlist: {
				p_pkval: '',
				expressid: '',
				p_batch: '',
				cname: '',
				starttime: '',
				endtime: '',
				fixfilter: '',
				fixsort: ''
			},
			searchbox: '',
			activeTabIndex: 0, //激活的选项卡index
			type: '',
			pickerOptions: '',
			packagelist: [],
			gridheight: (window.innerHeight * 68) / 100 + 'px',
			activeName: '',
			loading: false,
			pageindex: 0,
			pagesize: 200,
			search: '',
			sort: '',
			tabs: [],
			mode: '在途订单', //当前操作的功能模块名称
			filterlist: [], //常用筛选条件
			selectedall: false,
			checkedrow: [],
			printmode: [], //打印模板
			selectedprintmodeindex: 0,
			showprintwin: false,
			footerbtn_print: [{ name: '确定', event: 'goprint', type: 'primary' }],
			list: '',
			localprinter: '',
			batch: ''
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/ordermanager/ordermg.scss');
			this.getTabs();
		});
	},
	methods: {
		//获取选项卡
		getTabs() {
			this.$apipost.get.GetTabs({ parentid: 51 }).then(res => {
				this.tabs = res.tabs;
				let tab = this.tabs[0];
				this.activeName = tab.name;
				this.GetTabData();
			});
		},
		//清空筛选条件
		ClearSearch(type) {
			this.searchlist = {
				p_pkval: '',
				expressid: '',
				p_batch: '',
				cname: '',
				starttime: '',
				endtime: '',
				fixfilter: ''
			};
			if (type == 1) {
				this.searchbox = '';
			}
		},
		//获取表头方法
		GetTabData(tab) {
			if (tab != undefined) {
				this.activeTabIndex = tab.index;
			}
			this.GetFilter(); //加载选项卡对应的筛选条件
			this.GetPackageCount(); //获取汇总数
			if (this.tabs[this.activeTabIndex].columns.length == 0) {
				this.GetColumns();
			} else {
				this.refreshgrid(true);
			}
		},
		//刷新列表
		refreshgrid(isrefresh) {
			var that = this;
			//设置列表兼容性
			this.$tool.setgridstyle(that.$refs.orderlisttable, that.activeTabIndex);
			var isload = true;
			if (isrefresh) {
				this.packagelist = [];
				this.checkedrow = [];
				//刷新
				this.pageindex = 0;
				this.selectedall=false;
			} else {
				//加载下一页
				if (parseInt(this.tabs[this.activeTabIndex].pagecount - 1) > this.pageindex) {
					this.pageindex = this.pageindex + 1;
				} else {
					isload = false;
				}
			}
			if (isload) {
				this.loading = true;
				this.$apipost.get
					.GetPackageList({
						search: this.GetSearchObj(),
						tab: this.tabs[this.activeTabIndex].name,
						pageindex: this.pageindex,
						pagesize: this.pagesize,
						sort: this.sort,
						showcol: JSON.stringify(this.tabs[this.activeTabIndex].columns)
					})
					.then(res => {
						that.loading = false;
						if (res.data.length > 0) {
							if (that.pageindex > 0) {
								that.packagelist.push(res.data);
							} else {
								that.packagelist = res.data;
							}
						}
					});
			}
		},
		//组合筛选条件
		GetSearchObj() {
			var search = JSON.parse(JSON.stringify(this.searchlist));
			if (search.fixfilter != '') {
				var that = this;
				var searchtype = '';
				this.filterlist.forEach(e => {
					if (e.fname == search.fixfilter) {
						if (e.handlertype == 'filter') {
							searchtype = e.searchtype;
							return false;
						} else if (e.handlertype == 'sort') {
							searchtype = '';
							search.fixfilter = '';
							search.fixsort = e.filter;
							return false;
						}
					}
				});
				search.searchtype = searchtype;
			}
			search.p_pkval = search.p_pkval.replace(/\n/g, ',');
			search.expressid = search.expressid.replace(/\n/g, ',');
			if (this.searchbox != '') {
				search.searchbox = this.searchbox;
			}
			return JSON.stringify(search);
		},
		//获取列配置信息
		GetColumns() {
			var that = this;
			this.$apipost.get.GetColumns({ tab: this.tabs[this.activeTabIndex].type, checkfield: 1, parentid: this.tabs[this.activeTabIndex].id, mode: this.mode }).then(res => {
				that.tabs[that.activeTabIndex].columns = res;
				that.refreshgrid(true);
			});
		},
		//获取订单管理汇总表
		GetPackageCount() {
			var that = this;
			var type = this.tabs[this.activeTabIndex].type;
			this.$apipost.get.GetPackageCount({ tab: type, search: this.GetSearchObj() }).then(res => {
				if (res.state == '1') {
					for (var i = 0; i < that.tabs.length; i++) {
						if (type != '历史订单') {
							var countlist = res.countlist[0];
							for (var e in countlist) {
								if (e == that.tabs[i].type) {
									that.tabs[i].count = countlist[e];
									break;
								}
							}
						} else {
							var countlist = res.countlist[0];
							if (countlist[type] != undefined) {
								that.tabs[i].count = countlist[type];
								break;
							}
						}
					}
					that.setpagecount();
				}
			});
		},
		//设置分页显示数
		setpagecount() {
			var tabs = this.tabs;
			tabs.forEach(e => {
				if (parseInt(e.count) % this.pagesize == 0) {
					e.pagecount = parseInt(e.count) / this.pagesize;
				} else {
					e.pagecount = parseInt(parseInt(e.count) / this.pagesize) + 1;
				}
			});
		},
		//列表排序
		gridsort(e) {
			//e.column.prop--排序列名
			//e.column.order--ascending/descending --排序方式
			console.log('排序', e);
			this.sort = ' ' + e.column.prop + ' ' + e.column.order.replace('ending', '');
			this.refreshgrid(true);
		},
		//操作栏按钮触发事件
		buttonhandle(e) {
			if (e.event == 'exportorder') {
				this.ExportOrder();
			}
			if (e.event == 'delorder') {
				this.DelOrder();
			}
			if (e.event == 'printorder') {
				this.PrintOrder(2);
			}
		},
		//列表中的自定义列的操作事件
		gridhandle(e) {
			if (e.event == 'delorder') {
				this.checkedrow.push(this.packagelist[e.index]);
				this.DelOrder();
			}
			if (e.event == 'editorder') {
				Utils.$emit('go', { l_url: '/packagemanange/createorder', l_name: '修改订单', urlparam: { pkval: this.packagelist[e.index].p_pkval } });
			}
			if (e.event == 'showdetail') {
				Utils.$emit('go', { l_url: '/packagemanange/orderdetail', l_name: '订单详情', urlparam: { pkval: this.packagelist[e.index].p_pkval } });
			}
		},
		//底部操作按钮的单击事件
		footerhandle(e) {
			if (e.funname == 'goprint') {
				this.surebatchprintorder(batch, this.printmode[this.selectedprintmodeindex].e_code, 2);
			}
		},
		//关闭弹窗
		closedialog(e) {
			if (e.winname == 'selectprintmode') {
				this.showprintwin = false;
			}
		},
		//获取常用筛选条件
		GetFilter() {
			var that = this;
			this.$apipost.get.GetFilter({ l_mode: this.mode, type: this.tabs[this.activeTabIndex].type }).then(res => {
				if (res != '') {
					that.filterlist = res.data;
				}
			});
		},
		//设置常用筛选
		Setfilterchecked(value) {
			this.searchlist.fixfilter = value;
		},
		//复选框勾选触发
		checkboxchange(e) {
			if (!e.selectedall) {
				this.checkedrow = e.rows; //勾选了的列表
			}
			this.selectedall = e.selectedall;
		},
		//导入订单
		ExportOrder() {
			Utils.$emit('go', {
				l_url: '/packagemanange/orderinport',
				l_name: '订单导入',
				urlparam: { tab: this.tabs[this.activeTabIndex].type, mode: '订单管理导入', l_name: '订单导入' }
			});
		},
		//删除订单方法1/2
		DelOrder() {
			var searchinfo = this.GetCheckedOrder(false);
			if (searchinfo != '') {
				var that = this;
				this.$confirm('确定删除所选订单吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				})
					.then(() => {
						this.$tool.loading('正在获取勾选数据', 'ordermanager');
						this.$apipost.post.InsertTemp({ l_mode: that.mode, tab: that.tabs[that.activeTabIndex].type, search: searchinfo, sort: that.sort }).then(res => {
							this.$tool.loadingclose();
							if (res != '') {
								if (res.batch != '') {
									this.$tool.loading('正在删除', 'ordermanager');
									that.DelOrder2(res.batch);
								} else {
									this.$tool.message('获取数据失败', 0);
								}
							} else {
								this.$tool.message('获取数据失败', 0);
							}
						});
					})
					.catch(() => {});
			}
		},
		//删除订单方法2/2
		DelOrder2(batch) {
			var that = this;
			//console.log('删除订单',batch);
			//console.log('this.mode', this.mode);
			this.$apipost.post.SetOrderToTrash({ l_mode: this.mode, batch: batch, pkval: '', type: 1 }).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					this.$tool.message('操作成功', 1);
					that.refreshgrid(true);
					that.GetPackageCount(); //获取汇总数
				} else {
					this.$tool.message(res.message, 0);
				}
			});
		},
		//重置筛选
		ResetFilterInfo() {
			this.ClearSearch(1); //先清空筛选条件
			this.refreshgrid(true);
		},
		//获取勾选数据组合json
		GetCheckedOrder(isempty) {
			var pkval = '';
			var isgo = true;
			var search = {
				p_pkval: ''
			};
			var searchinfo = '';
			if (!this.selectedall) {
				this.checkedrow.forEach(e => {
					pkval += e.p_pkval + ',';
				});
				if (pkval != '') {
					pkval = pkval.substring(0, pkval.length - 1);
					search.p_pkval = pkval; //这里的筛选条件对象的结构与订单筛选条件结构一致
					searchinfo = JSON.stringify(search);
				} else {
					if (!isempty) this.$tool.message('请勾选订单', 2);
				}
			} else {
				searchinfo = this.GetSearchObj();
			}
			return searchinfo;
		},
		//批量打印面单
		PrintOrder(type) {
			var that = this;
			var searchinfo = this.GetCheckedOrder(false);
			if (searchinfo != '') {
				//判断打印控件
				if (this.$tool.checkprintcontrol()) {
					this.$tool.loading('正在获取勾选数据', 'ordermanager');
					this.$apipost.post.InsertTemp({ l_mode: that.mode, tab: that.tabs[that.activeTabIndex].type, search: searchinfo, sort: that.sort }).then(res => {
						this.$tool.loadingclose();
						if (res != '') {
							if (res.batch != '') {
								that.batch = res.batch;
								that.OpenPrint(res.batch, type);
							} else {
								this.$tool.message('获取数据失败', 0);
							}
						} else {
							this.$tool.message('获取数据失败', 0);
						}
					});
				} else {
					this.$tool.opendowncontrol();
				}
			}
		},
		//单个打印面单
		PrintOrder_signle() {
			//判断打印控件
		},
		//打印
		OpenPrint(batch, type) {
			var that = this;
			var title = '打印面单';
			if (type == 1) {
				title = '取单号';
			} else if (type == 3) {
				title = '生成面单';
			} else if (type == 2) {
				type = '';
			} else if (type == 4) {
				title = '生成PDF';
			}
			this.$tool.loading('正在' + title, 'ordermanager');
			if (type != 3) {
				this.$apipost.get.CheckPmodetoPrint({ batch: batch }).then(res => {
					that.localprinter = that.$tool.getlocalprinterstr();
					if (res.type == '1') {
						//弹出下拉选项让用户自己选择打印哪个模板
						var result = res.list;
						if (result.length == 1) {
							//表示只有一个渠道
							that.$apipost.get.GetPrintBzMode({ batch: batch, pmode: result[0].p_mode }).then(res => {
								if (res.list != '') {
									if (res.list.length > 0) {
										if (res.list.length == 1) {
											//表示只有一个打印模板，可以直接调用打印方法
											that.surebatchprintorder(batch, res.list[0].e_code, type);
										} else {
											this.$tool.loadingclose();
											//表示有多个打印模板，需弹出选择
											that.selectedprintmodeindex = 0;
											that.printmode = res.list;
											that.showprintwin = true;
										}
									}
								}
							});
						} else {
							this.$tool.loadingclose();
							this.$tool.message('所选订单包含不同的渠道，无法批量打印', 0);
						}
					} else {
						//根据订单的渠道，自动打印对应口岸的模板（仅用于一个口岸对应一个打印模板的业务类型，如果对应了多个打印模板，则弹出窗口选择）
						that.surebatchprintorder(batch, '', type);
					}
				});
			}
		},
		surebatchprintorder(batch, ecode, type) {
			var that = this;
			this.$apipost.get.GetTempBatch({ batch: batch }).then(res => {
				if (res.list != '') {
					if (res.list.length > 0) {
						that.printorderbatch(res.list, 0, type, ecode);
					}
				}
			});
		},
		//循环按顺序打印
		printorderbatch(list, index, type, ecode) {
			var that = this;
			if (list.length > index) {
				var printinfo = new Object();
				printinfo.pkval = list[index].orderid;
				printinfo.ecode = ecode;
				printinfo.index = parseInt(index) + 1;
				printinfo.printer = this.localprinter;
				printinfo.u_account = localStorage.getItem('u_account');
				printinfo.userid = localStorage.getItem('userid');
				printinfo.type = type;
				console.log(JSON.stringify(printinfo));
				this.$apipost.get
					.GetOrderPrint({ printinfo: JSON.stringify(printinfo) })
					.then(res => {
						if (res.data != '') {
							var result = res.data;
							if (result.message == undefined) {
								eval(result);
								index = parseInt(index) + 1;
								that.printorderbatch(list, index, type, ecode);
							} else {
								this.$tool.loadingclose();
								if (result.state == '0') {
									this.$tool.alertmessage(result.message);
									setTimeout(function() {
										that.showprintwin = false;
									}, 1000);
								}
								index = list.length + 1;
							}
						} else {
							this.$tool.loadingclose();
							this.$tool.message('打印异常，请重试', 0);
							setTimeout(function() {
								that.showprintwin = false;
							}, 1000);
						}
					})
					.catch(err => {});
			} else {
				this.$tool.loadingclose();
				this.$tool.message('打印完成', 1);
				that.refreshgrid(true);
				that.GetPackageCount(); //获取汇总数
				setTimeout(function() {
					that.showprintwin = false;
				}, 1000);
			}
		},
		//更改选择模板下拉选项
		changeprintmode(index) {
			this.selectedprintmodeindex = index;
		}
	}
};
</script>
